import React from 'react';

function UpdateName() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const jsonData = {};
    for (let [key, value] of data) {
      jsonData[key] = value;
    }
    fetch("/updatename", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          alert("נשלח אליך מייל להמשך עידכון הפרטים");
          window.location = "/updatename";
        } else {
          alert(res.err);
        }
      });
  }

  function deleteNameSubmit() {
    fetch("/deletename", {
      method: "POST",
      headers: { "content-type": "application/json" },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isFix) {
          alert(res.err);
          window.location = "/";
        } else {
          alert(res.err);
        }
      });
  }

  return (
    <div className="container mt-5" dir="rtl">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h2 className="card-title text-center mb-4">עדכון פרטים</h2>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">הכנס מייל בעת ההרשמה:</label>
                  <input type="email" name="email" className="form-control" required />
                </div>
                <div className="d-grid">
                  <button type="submit" className="btn btn-primary">
                    שלח מייל לעדכון
                  </button>
                </div>
              </form>
              <hr className="my-4" />
              <div className="alert alert-warning text-center" role="alert">
                <p className="mb-2">
                  אם ברצונך להימחק מהמערכת, יש למחוק תחילה את כל המוצרים שפרסמת.
                </p>
                <button className="btn btn-danger" onClick={deleteNameSubmit}>
                  מחיקה מהמערכת
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateName;
